// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__12VId","search":"Settings_search__aZYBX","filter":"Settings_filter__19S8x"};